import React from "react";
import "./questionModal.css";

const QuestionModal = ({
  visible,
  onClose,
  onSubmit,
  feedback,
  setFeedback,
  documentLabel = "quote",
}) => {
  if (!visible) return null;

  return (
    <div
      className="modal_overlay quote-decline-modal-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="modal_content quote-decline-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-decline-modal-title"
      >
        <div className="quote-decline-modal__heading">
          <div>
            <span className="basket-panel-eyebrow">
              {documentLabel} response
            </span>
            <h3 id="quote-decline-modal-title">
              Decline {documentLabel}
            </h3>
            <p>
              If you can, let us know why so our team can improve the offer.
            </p>
          </div>
          <button
            type="button"
            className="basket-debug-modal__close"
            aria-label={`Close decline ${documentLabel}`}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <form
          className="quote-decline-modal__form"
          onSubmit={(event) => {
            event.preventDefault();
            onSubmit();
          }}
        >
          <label className="quote-decline-modal__field">
            <span>Reason or feedback (optional)</span>
            <textarea
              rows="5"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Tell us what we could do better"
            />
          </label>

          <div className="quote-decline-modal__actions">
            <button
              type="button"
              className="button-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="submit" className="quote-decline-modal__submit">
              Decline {documentLabel}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default QuestionModal;
